import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { PassRedeemFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPassRedeemPOSTErrorResponse, ParkPassRedeemPOSTRequest, ParkPassRedeemPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchPassRedeem = async (data: ParkPassRedeemPOSTRequest): Promise<ParkPassRedeemPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPassRedeemPOSTSuccessResponse>("/pass-redeem", data);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPassRedeemPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PassRedeemFailReason };
  }
};
